import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, TrendingUpIcon } from 'lucide-react';
const testimonials = [{
  name: 'Ashley M.',
  location: 'Orlando, FL',
  quote: "I went from being a receptionist making minimum wage to having a fully booked calendar in Orlando. In my first week using the Blueprint, I made $850. I couldn't believe it!",
  result: '$3,200 net profit in her first month.'
}, {
  name: 'Mariana R.',
  location: 'Houston, TX',
  quote: 'I was terrified of the paperwork and license requirements in Texas. The Legal Bonus gave me the peace of mind I needed. Today I work from my converted garage and make more than my husband.',
  result: '15 recurring clients in 20 days.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function SocialProof() {
  return <section className="py-20 px-4 bg-slate-50" data-id="element-154">
      <div className="max-w-5xl mx-auto" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-157">
            Join Women Who Are Already Changing Their Lives
          </h2>
          <p className="text-lg text-slate-600" data-id="element-158">
            Real results from independent nail techs across the USA.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-2 gap-8" data-id="element-159">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={cardVariants} className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100 relative" data-id="element-160">
              <div className="flex gap-1 mb-6" data-id="element-161">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-162" />)}
              </div>

              <p className="text-slate-700 text-lg italic mb-8 leading-relaxed" data-id="element-163">
                "{testimonial.quote}"
              </p>

              <div className="mt-auto pt-6 border-t border-slate-100" data-id="element-164">
                <div className="font-bold text-slate-900" data-id="element-165">
                  {testimonial.name}
                </div>
                <div className="text-slate-500 text-sm mb-4" data-id="element-166">
                  {testimonial.location}
                </div>

                <div className="bg-rose-50 rounded-lg p-4 flex items-start gap-3" data-id="element-167">
                  <TrendingUpIcon className="w-5 h-5 text-rose-500 shrink-0 mt-0.5" data-id="element-168" />
                  <div data-id="element-169">
                    <span className="block text-xs font-bold text-rose-700 uppercase tracking-wider mb-1" data-id="element-170">
                      Result
                    </span>
                    <span className="text-rose-900 font-medium" data-id="element-171">
                      {testimonial.result}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}